import {getCall, listCall,postCall, putCall, delCall} from "./commonApi";

export async function getDetails(entityName, id) {
    let res = await getCall('/general/get/'+entityName+'/'+id);
    return res;
}

export async function list(entityName,orgId) {
    let res = await listCall('/list/'+entityName+'?orgId='+orgId);
    return res;
}

export async function listAll(entityName) {
    let res = await listCall('/list/'+entityName);
    return res;
}

export async function addRecord(entityName,data) {
    let res = await postCall("/general/create/"+entityName,data);
    return res;
}

export async function updateRecord(entityName,id,data) {
    let res = await putCall("/general/update/"+entityName+"/"+id,data);
    return res;
}

export async function deleteRecord(entityName,id) {
    let res = await delCall("/general/delete/"+entityName+"/"+id);
    return res;
}

export async function podcastRelease(id, data) {
    let res = await putCall("/general/releaseProdcast/"+id,data);
    return res;
}

export async function getUploadHistory(uploadId=null) {
    let res;
    if(uploadId === null){
        res = await getCall("/general/getUploadHistory");
    } else {
        res = await getCall("/general/getUploadHistory?uploadId="+uploadId);
    }
    return res;
}

export async function noAuthApi(path) {
    let res = await listCall(path);
    return res;
}